import { useNotification } from "app/NotificationProvider";
import { AnalyticsEvents, analytics } from "common/analytics";
import EventFormDialog from "common/components/EventFormDialog";
import { useTranslation } from "common/locales";
import { GeneralFeedEvent, useUpdateFeedEvent } from "model";
import { useCurrentFarm } from "model/useFarmQueries";
import { Dispatch, SetStateAction, useRef } from "react";
import EnterFeedEvent from "./EnterFeedEvent";

export default function UpdateFeedEvent({
  feedEvent,
  dialogOpen,
  setDialogOpen,
}: {
  feedEvent: GeneralFeedEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const { notify } = useNotification();
  const { t } = useTranslation();
  const updateFeedEventMutation = useUpdateFeedEvent();
  const dirtyRef = useRef(false);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const { data: currentFarm } = useCurrentFarm();

  async function handleSave(generalFeedEvent: GeneralFeedEvent) {
    await updateFeedEventMutation.mutateAsync({
      generalFeedEvent,
      farmGuid: currentFarm?.guid ?? "",
    });
    notify(t("addFeedEvent.add.success"));
    analytics.track(AnalyticsEvents.FEED_EVENT_UPDATED);
    handleClose();
  }

  return (
    <EnterFeedEvent
      feedEvent={feedEvent}
      handleSave={handleSave}
      dirtyRef={dirtyRef}
    >
      {({ steps, submitForm }) => (
        <EventFormDialog
          open={dialogOpen}
          onClose={handleClose}
          title={t("feedEventInput.title")}
          onSave={submitForm}
          isDirty={() => dirtyRef.current}
          cancelAnalyticsEvent={AnalyticsEvents.FEED_EVENT_UPDATE_CANCELLED}
          steps={steps}
        />
      )}
    </EnterFeedEvent>
  );
}
